import React from 'react'
import reactStamp from 'react-stamp'
import req from 'reqwest';
import Devices from '../components/Devices'

export default reactStamp(React).compose({

    init(){
        this.checkFitbit();
        this.fitbitAuthorize = this.fitbitAuthorize.bind(this);
        this.fitbitUnAuthorize = this.fitbitUnAuthorize.bind(this);
        this.startChecking();
        this.state.fitbit = sessionStorage.getItem('fitbit');
    },

    state: {},

    startChecking() {
        this.checkFitbit();
    },

    render() {
        return (
            <Devices
                fitbitAuthorize={this.state.fitbit=="false" ? this.fitbitAuthorize : this.fitbitUnAuthorize}
                authorizedFitbit={this.state.fitbit}
            />
        );
    },

    checkFitbit() {
        let id = sessionStorage.getItem("id");
        req({
            url: "https://dev-fitness2crm-sync-process-api.cloudhub.io/api/patients/" + id,
            method: 'GET',
            crossOrigin: true,
             type: 'json'
        })
            .then((resp) => this.handleCheckFitbitResponse(resp))
            .fail((err, msg) => this.handleCheckFitbitError(err, msg))
            .always((resp) => {
            })
    },

    handleCheckFitbitResponse(resp){

        sessionStorage.setItem('fitbit', resp.isAuthorized);
        this.setState({fitbit: resp.isAuthorized+""})
    },

    handleCheckFitbitError(err, msg){
       if (err.status != "200") {
            sessionStorage.setItem('fitbit', false);
            this.setState({fitbit: "false"})
        } else {
            sessionStorage.setItem('fitbit', true);
            this.setState({fitbit: "true"})
        }
    },

    fitbitAuthorize() {
        let id = sessionStorage.getItem("id");
        req({
            url: "https://dev-fitness2crm-sync-process-api.cloudhub.io/api/patients/" + id + "/authorize",
            method: 'POST',
            crossOrigin: true
        })
            .then((resp) => this.handleFitbitAuthorizeResponse(resp))
            .fail((err, msg) => this.handleFitbitAuthorizeError(err, msg))
            .always((resp) => {
            })
    },

    handleFitbitAuthorizeResponse(resp){
        this.popupCenter(resp.location, "FitBit login", 700, 700);
    },

    handleFitbitAuthorizeError(err, msg){
    },

    fitbitUnAuthorize() {
        let id = sessionStorage.getItem("id");
        req({
            url: "https://dev-fitness2crm-sync-process-api.cloudhub.io/api/patients/" + id + "/unauthorize",
            method: 'GET',
            crossOrigin: true
        })
            .then((resp) => this.handleFitbitUnAuthorizeResponse(resp))
            .fail((err, msg) => this.handleFitbitUnAuthorizeError(err, msg))
            .always((resp) => {
            })
    },

    handleFitbitUnAuthorizeResponse(resp){
        sessionStorage.setItem('fitbit', false);
        this.setState({fitbit: "false"})
    },

    handleFitbitUnAuthorizeError(err, msg){
    },

    popupCenter(url, title, w, h) {
        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        var left = ((width / 2) - (w / 2)) + dualScreenLeft;
        var top = ((height / 2) - (h / 2)) + dualScreenTop;
        var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        if (window.focus) {
            newWindow.focus();
        }
    }


});





/** WEBPACK FOOTER **
 ** ./src/app/containers/Devices.js
 **/